import React from "react";
import { Popover } from "@material-ui/core";
import "./index.css";

const CustomPopoverMui = ({ open, anchorEl, handleClose, children, id }) => {
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      PaperProps={{
        style: {
          borderRadius: 8,
          maxHeight: 400,
          overflowY: "auto",
          width: anchorEl ? anchorEl.clientWidth : undefined,
        },
      }}
    >
      {children}
    </Popover>
  );
};

export default CustomPopoverMui;
